import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { ConfirmOrderTable } from "../features/purchase/ConfirmOrderTable";
import { ConfirmForm, ConfirmHeader, ConfirmReceipt } from "../features/purchase/ConfirmParts";
import { fetchConfirmView, submitConfirmation } from "../api/purchaseConfirm";
import "../features/purchase/confirm.css";

// صفحة عامة للمورّد (بلا حساب): يرى الأمر ويؤكده بتوقيعه.
export default function PurchaseConfirmPage() {
  const { t } = useTranslation();
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ name: "", notes: "", signature: "", agreed: false });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => {
    fetchConfirmView(token)
      .then(setData)
      .catch((err) => setError(err?.response?.data?.detail?.code || "confirmation_link_not_found"));
  }, [token]);

  const submit = async () => {
    setBusy(true);
    try {
      setDone(await submitConfirmation(token, {
        confirmed_by_name: form.name, signature: form.signature, notes: form.notes,
      }));
    } catch (err) {
      toast.error(t(`purchases.confirm.errors.${err?.response?.data?.detail?.code}`,
                    t("errors.generic")));
    } finally {
      setBusy(false);
    }
  };

  if (error) {
    return (
      <main className="pc">
        <div className="pc-box">
          <section className="pc-card" data-testid="confirm-error">
            <div className="pc-head" style={{ background: "#7f1d1d" }}>
              <p style={{ fontWeight: 800 }}>{t(`purchases.confirm.errors.${error}`, error)}</p>
            </div>
          </section>
        </div>
      </main>
    );
  }
  if (!data) return <main className="pc" />;

  return (
    <main className="pc" data-testid="purchase-confirm-page">
      <div className="pc-box">
        <ConfirmHeader company={data.company} order={data.order} />
        <ConfirmOrderTable order={data.order} />
        {done || data.already_confirmed ? (
          <ConfirmReceipt name={done?.confirmed_by || data.confirmed_by}
                          at={done?.confirmed_at}
                          signature={form.signature}
                          total={data.order.totals?.payable}
                          currency={data.order.currency}
                          token={token} />
        ) : (
          <ConfirmForm form={form} setForm={setForm} busy={busy} onSubmit={submit} />
        )}
      </div>
    </main>
  );
}
